import React, { useEffect, useState } from 'react';

import { Configuration, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

const config: Configuration = {
  auth: {
    clientId: '62db711b-b13c-43fb-959d-158d0ed8447a',
    authority: 'https://login.microsoftonline.com/5b268d57-2a6f-4e04-b0de-6938583d5ebc',
    redirectUri: 'https://adc-launchpad-qa.abbott.com/auth-response',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'User.Read'],
};

const pca = new PublicClientApplication(config);

// Initialize MSAL
pca.initialize().catch(error => {
  console.error('MSAL initialization failed:', error);
});

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    pca
      .initialize()
      .then(() => {
        console.log('MSAL initialized successfully');
        setIsInitialized(true);
      })
      .catch(error => {
        console.error('MSAL initialization failed:', error);
        setIsInitialized(true); // Still set to true so app can proceed with fallback
      });
  }, []);

  // Show loading state while MSAL initializes
  if (!isInitialized) {
    return <div>Loading authentication...</div>;
  }

  return <MsalProvider instance={pca}>{children}</MsalProvider>;
}
